import wash from "assets/imgs/wash.webp";
import coffee from "assets/imgs/coffee.png";
import test from "assets/imgs/test.webp";
import vypex from "assets/imgs/vypex.png";
import company from "assets/imgs/company.webp";
import barber from "assets/imgs/barber.png";
import tariff from "assets/imgs/tariff.png";
import school from "assets/imgs/school.webp";
import furniture from "assets/imgs/furniture.png";
import uch from "assets/imgs/uch.webp";
import transio from "assets/imgs/transio.webp";

const works = [
  {
    category: "Web,Platform",
    img: transio,
    titleKey: "projectsPage.transio.title",
    tags: ["React", "CRM", "Logistics", "Dashboard", "API"],
    link: "https://www.trans-io.com",
  },
  {
    category: "Web",
    img: uch,
    titleKey: "projectsPage.uch.title",
    tags: ["React", "IT Company", "Corporate", "Responsive UI"],
    link: "https://uchdev.co/",
  },
  {
    category: "Web",
    img: school,
    titleKey: "projectsPage.school.title",
    tags: ["React", "TypeScript", "CSS", "HTML5", "Api"],
    link: "https://edu-algoritm.uz/",
  },
  {
    category: "Web",
    img: barber,
    titleKey: "projectsPage.barber.title",
    tags: ["React", "TypeScript", "CSS", "Vite", "Telegram Api"],
    link: "https://bymcutsp9rj.setmore.com/",
  },
  {
    category: "Web",
    img: tariff,
    titleKey: "projectsPage.tariff.title",
    tags: ["React", "TypeScript", "Next.js", "CSS", "Vite"],
    link: "https://tariff-seven.vercel.app/",
  },
  {
    category: "Web",
    img: furniture,
    titleKey: "projectsPage.furniture.title",
    tags: ["React", "Vite", "CSS", "HTML5", "Api"],
    link: "http://furniture-jade-iota.vercel.app/",
  },
  {
    category: "Web",
    img: company,
    titleKey: "projectsPage.company.title",
    tags: ["React", "TypeScript", "CSS", "Vite"],
    link: "https://swiftcore.uz",
  },
  {
    category: "Web",
    img: test,
    titleKey: "projectsPage.english_test.title",
    tags: ["React", "TypeScript", "AI"],
    link: "https://testify-quiz.vercel.app/",
  },
  {
    category: "Web",
    img: vypex,
    titleKey: "projectsPage.vypex.title",
    tags: ["React", "TypeScript", "CSS", "HTML5", "Vite"],
    link: "https://tokenweb05.netlify.app/",
  },
  {
    category: "Web,Platform",
    img: coffee,
    titleKey: "projectsPage.coffee_delivery.title",
    tags: ["React", "TypeScript", "CSS", "HTML5", "Vite"],
    link: "https://market-hpz4b0ikg-ogabeks-projects-e228d171.vercel.app/",
  },
  {
    category: "Web",
    img: wash,
    titleKey: "projectsPage.washcam.title",
    tags: ["React", "JavaScript", "CSS", "HTML5"],
    link: "https://wash-cam.vercel.app/",
  },
];

export default works;
